exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".sc-transfer {\n  width: 100%;\n  padding-top: 10px;\n}\n.sc-transfer .ant-btn-primary[disabled] {\n  background-color: #f5f5f5 !important;\n  border-color: #d9d9d9 !important;\n  color: rgba(0,0,0,0.25);\n}\n.sc-transfer .ant-transfer-list {\n  width: calc(50% - 23px);\n  height: 320px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/AntD/assets/stylus/com/dataentry/transfer.styl
// module id = 3782
// module chunks = 0